import { useMemo } from 'react'
import type React from 'react'

export interface DotIndicatorProps {
  /** 1-based index of the active indicator. */
  state?: number
  /** Total number of indicators to display. */
  count?: number
  animated?: boolean
}

export const DotIndicator: React.FC<DotIndicatorProps> = ({
  state = 1,
  count = 3,
  animated = true,
}) => {
  const total = Math.max(1, Math.round(count))
  const activeIndex = Math.max(0, Math.min(total - 1, Math.round(state) - 1))
  const base = 'h-1 rounded-[3px] bg-black shrink-0'
  const anim = animated ? ' transition-all duration-200 ease-out' : ''
  const dots = useMemo(
    () => Array.from({ length: total }, (_, index) => ({ id: `dot-${index}` })),
    [total]
  )

  return (
    <div className="content-stretch flex gap-1.5 items-center justify-start relative">
      {dots.map((dot, index) => (
        <div
          key={dot.id}
          className={base + anim + (index === activeIndex ? ' w-3 opacity-100' : ' w-1 opacity-60')}
          aria-hidden={index !== activeIndex}
        />
      ))}
    </div>
  )
}

export default DotIndicator
